import {convertToHm, yesterday} from "@/Utilites/timerHelper";
import DEFAULT_CONSTANTS from "@/Utilites/constants";
import {removeEmptyLines, strIs} from "@/Utilites/helper";

export function formatTimerDescription(desc) {
  const res = removeEmptyLines(desc).split("\n");
  let newDesc = "";
  for (let i = 0; i < res.length; i++) {
    newDesc += "\n            ○   " + res[i];
  }
  return newDesc;
}

export function mapIdToProjectName(projectNameList, id) {
  if (!strIs(id)) return "Project Not Selected";
  const row = projectNameList.find((item) => item.id === id);
  return row && row.project_name ? row.project_name : "Unknown project";
}

export function formatClipBoardText(timerList, projectNameList, selectedDate) {
  let totalHours = 0;
  let text = "";
  let dayHeader =
    selectedDate === yesterday() ? "Yesterday / " : selectedDate + " / ";
  for (let i = 0; i < timerList.length; i++) {
    totalHours += timerList[i].hours;
    text +=
      "  •   " +
      mapIdToProjectName(projectNameList, timerList[i].project_id) +
      " / " +
      convertToHm(timerList[i].hours * DEFAULT_CONSTANTS.toSecond) +
      formatTimerDescription(timerList[i].task_description) +
      "\n";
  }
  text =
    dayHeader +
    convertToHm(totalHours * DEFAULT_CONSTANTS.toSecond) +
    "\n" +
    text +
    "Today:\n<TODO>\nBlockages:\n<TODO>";
  return text;
}

export function mapIdToUserName(getTeamNameList, id) {
  const row = getTeamNameList.find((item) => item.id === id);
  return row && row.full_name ? row.full_name : "Unknown";
}
